export const TravelLineStatus = {
  Unchanged: 'unchanged',
  New: 'new',
  Modified: 'modified',
  Deleted: 'deleted',
} as const;

export type TravelLineStatusType = (typeof TravelLineStatus)[keyof typeof TravelLineStatus];

interface TravelLineBase {
  lineKey: number;
  startDate: string;
  endDate: string;
  destinationBranchId: string;
  crewMemberIds: string[];
}

export interface NewTravelLine extends TravelLineBase {
  status: typeof TravelLineStatus.New;
  id?: undefined;
}

export interface SavedTravelLine extends TravelLineBase {
  status:
    | typeof TravelLineStatus.Unchanged
    | typeof TravelLineStatus.Modified
    | typeof TravelLineStatus.Deleted;
  id: string;
}

export type TravelLineState = NewTravelLine | SavedTravelLine;

export type PickerPlacement = 'above' | 'below';
